import pushPathnameToToHistoryStack from './pushPathnameToToHistoryStack';

export default pushPathnameToToHistoryStack;
